import { observer } from 'mobx-react-lite'
import { type JobProgressionViewModel } from '@/features/jobs/details/components/JobProgressionCard/JobProgressionViewModel'
import { JobExtensionConfirmedProgressionActions } from '@/features/jobs/details/components/JobProgressionCard/JobExtensionConfirmedProgressionActions'

export interface JobExtensionConfirmedProgressionActionsContainerProps {
  vm: JobProgressionViewModel
}

export const JobExtensionConfirmedProgressionActionsContainer = observer(
  function JobExtensionConfirmedProgressionActionsContainer({
    vm,
  }: JobExtensionConfirmedProgressionActionsContainerProps) {
    return (
      <JobExtensionConfirmedProgressionActions
        onExtensionAccepted={vm.answerJobExtensionAccepted}
        onExtensionRejected={vm.answerJobExtensionRejected}
      />
    )
  },
)
